import { BaseBackgroundDrawer } from './BaseBackgroundDrawer';
import { GameLayers } from '../../../core/enums';
import { resourceHelper } from '../../../core/resourceHelper';
import { webSourceNames } from '../../../core/sourceNames';
import { landScapeConfig, webConfig } from '../../../core/applicationConfig';
import { translationKeys } from '../../../core/translation/translation';
import { amountTextStyle } from '../../../core/textStyles';
import { popupService } from '../../../services/helperServices/PopupService';
import { BONUS_COST_AMOUNT } from '../../../stateManagment';
import { getAmount } from '../../../core/helpers/getAmount';

export class BackgroundLandscapeDrawer extends BaseBackgroundDrawer {
  constructor() {
    super();
    this.winOddConfigs = {
      containerPosition: {
        x: landScapeConfig.width / 2,
        y: 360,
      },
      shadowScale: 4,
      oddStart: 350,
      oddEnd: -80,
      winStart: 350,
      winEnd: 10,
      winFontSize: 75,
      oddFontSize: 80,
    };

    this.multiplierConfigs = {
      oddStart: 350,
      oddEnd: -80,
      oddFontSize: 80,
    }
  }

  setBackground() {
    const texture = this.createSprite(resourceHelper.get(webSourceNames.background));
    this.container[GameLayers.background].addChild(texture);
  }

  setShadow() {
    const texture = this.createSprite(resourceHelper.get(webSourceNames.shadow));
    this.container[GameLayers.shadow].addChild(texture);
  }

  setDragonForceBack() {
    const texture = this.createSprite(resourceHelper.get(webSourceNames.tikiBack));
    this.setPosition(texture, landScapeConfig.bgPosition);
    this.container[GameLayers.dragonForceBack].addChild(texture);
  }

  setDragonForce() {
    const texture = this.createSprite(resourceHelper.get(webSourceNames.tiki));
    this.setPosition(texture, landScapeConfig.bgPosition);
    this.container[GameLayers.dragonForce].addChild(texture);
  }

  setWallAnimationTexture() {
    const texture = this.createSpine(resourceHelper.get(webSourceNames.wallSpine));
    this.setPosition(texture, landScapeConfig.staticAnimationPosition);
    this._setupWallAnimations(texture);
    this.container[GameLayers.wallSpine].addChild(texture);
  }

  setWaterAnimationTexture() {
    super._setBackground({
      name: webSourceNames.waterSpine,
      containerName: GameLayers.waterSpine,
      position: landScapeConfig.staticAnimationPosition,
    });
  }

  setFishAnimationTexture() {
    this._setFishAnimationTexture({
      name: webSourceNames.fishSpine,
      position: landScapeConfig.staticAnimationPosition,
    });
  }

  setWaterFallAnimationTexture() {
    super._setBackground({
      name: webSourceNames.waterfallSpine,
      containerName: GameLayers.waterfallSpine,
      position: landScapeConfig.staticAnimationPosition,
    });
  }

  setTreesAnimationTexture() {
    super._setBackground({
      name: webSourceNames.treesSpine,
      containerName: GameLayers.treesSpine,
      position: landScapeConfig.staticAnimationPosition,
    });
  }

  setDragonAnimationTexture() {
    const texture = this.createSpine(resourceHelper.get(webSourceNames.dragonSpine));
    this.setPosition(texture, landScapeConfig.staticAnimationPosition);
    this._setupDragonAnimations(texture);
    this.container[GameLayers.dragonSpine].addChild(texture);
  }

  setBreakingBallSpineTexture() {
    this._setBreakingBallSpineTexture({
      name: webSourceNames.breakingBallSpine,
      position: landScapeConfig.staticAnimationPosition,
    });
  }

  setDragonSoulAnimationTexture() {
    this._setDragonSoulAnimationTexture({
      name: webSourceNames.dragonSoulSpine,
      position: landScapeConfig.staticAnimationPosition,
    });
  }

  setWinOdd(res) {
    return super.setWinOdd(res, {
      position: this.winOddConfigs.containerPosition,
      winOddConfigs: this.winOddConfigs,
    });
  }

  setBuyBonusButton() {
    const container = this.createContainer('container');
    const buttonTexture = this.createSprite(resourceHelper.get(webSourceNames.buyBonusButton));
    const titleTexture = this.createText(translationKeys.buyBonus, {
      ...amountTextStyle,
      fontSize: 33,
      fontWeight: 900,
    });

    const valuesTexture = this.createText(getAmount(BONUS_COST_AMOUNT.getValue()), {
      ...amountTextStyle,
      fontSize: 33,
      fontWeight: 900,
    });

    titleTexture.anchor.set(.5);
    valuesTexture.anchor.set(.5);
    buttonTexture.anchor.set(.5);
    buttonTexture.scale.set(1);
    this.setPosition(container, { x: webConfig.width / 2, y: 250 });
    this.setPosition(titleTexture, { x: 0, y: 5 });
    this.setPosition(valuesTexture, { x: 0, y: 35 });
    container.addChild(
      buttonTexture,
      titleTexture,
      valuesTexture,
    );
    this.setupButtonMode(buttonTexture);
    this.registerClick(buttonTexture, () => popupService.openBuyBonusPopup());
    this.container[GameLayers.dragonForceBack].addChild(container);
  }

  setStaticAnimations() {
    this.setWallAnimationTexture();
    this.setWaterAnimationTexture();
    this.setFishAnimationTexture();
    this.setWaterFallAnimationTexture();
    this.setTreesAnimationTexture();
    this.setDragonAnimationTexture();
    this.setBreakingBallSpineTexture();
    this.setDragonSoulAnimationTexture();
    this.setBuyBonusButton();
  }
}
